import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiConstants } from "../constants/api.constants";
import { setAlert } from "./alertSlice";
import { authentication } from "./authSlice";
import { commonService } from "../service/common.service";
import { history } from "../_helper/history";
import swal from "sweetalert";
import { Navigate } from "react-router-dom";

const url = process.env.REACT_APP_BACKEND_URL + process.env.REACT_APP_BASE_API;

export const createCollection = createAsyncThunk(
  apiConstants.CREATE_COLLECTION,
  async (data, { dispatch, rejectWithValue }) => {
    return commonService
      .withTokenAndFormData(apiConstants.CREATE_COLLECTION, data)
      .then((response) => {
        if (response.data.success) {
          dispatch(
            setAlert({
              msg: "Collection Created successfully",
              alertType: "success",
              timeout: 3000,
            })
          );
          Navigate("/Collections");
        }
        return response.data.success;
      })
      .catch(async (err) => {
        let result = await errorHandler(err.response);
        dispatch(
          setAlert({
            msg: JSON.stringify(result),
            alertType: "error",
            timeout: 3000,
          })
        );
        rejectWithValue(err);
      });
  }
);

export const getAllCollections = createAsyncThunk(
  apiConstants.GET_ALL_COLLECTIONS,
  async (data,{ dispatch, rejectWithValue }) => {
    return commonService
      .withOutToken(`${apiConstants.GET_ALL_COLLECTIONS}?search=${data.search}`, data)
      .then((response) => {
        if (response.data.success) {
          // dispatch(
          //   setAlert({
          //     msg: "Get Collection successfully",
          //     alertType: "success",
          //     timeout: 3000,
          //   })
          // );
        }
        return response.data;
      })
      .catch(async (err) => {
        let result = await errorHandler(err.response);
        dispatch(
          setAlert({
            msg: JSON.stringify(result),
            alertType: "error",
            timeout: 3000,
          })
        );
        rejectWithValue(err);
      });
  }
);

export const getAllCollectionsByCreator = createAsyncThunk(
  apiConstants.GET_ALL_COLLECTIONS_BY_CREATOR,
  async (data, { dispatch, rejectWithValue }) => {
    return commonService
      .withOutToken(`${apiConstants.GET_ALL_COLLECTIONS_BY_CREATOR}?search=${data.search}`, data)
      .then((response) => {
        return response.data;
      })
      .catch(async (err) => {
        let result = await errorHandler(err.response);
        dispatch(
          setAlert({
            msg: JSON.stringify(result),
            alertType: "error",
            timeout: 3000,
          })
        );
        rejectWithValue(err);
      });
  }
);

export const getAllCollectionsByName = createAsyncThunk(
  apiConstants.GET_ALL_COLLECTIONS_BY_NAME,
  async (data, { dispatch, rejectWithValue }) => {
    return commonService
      .getDataWithToken(apiConstants.GET_ALL_COLLECTIONS_BY_NAME, data)
      .then((response) => {
        return response.data.collections;
      })
      .catch(async (err) => {
        let result = await errorHandler(err.response);
        dispatch(
          setAlert({
            msg: JSON.stringify(result),
            alertType: "error",
            timeout: 3000,
          })
        );
        rejectWithValue(err);
      });
  }
);

export const getCollectionById = createAsyncThunk(
  apiConstants.GET_COLLECTION_BY_ID,
  async (data, { dispatch, rejectWithValue }) => {
    return commonService
      .withOutToken(apiConstants.GET_COLLECTION_BY_ID, data)
      .then((response) => {
        return response.data.collection;
      })
      .catch(async (err) => {
        let result = await errorHandler(err.response);
        dispatch(
          setAlert({
            msg: JSON.stringify(result),
            alertType: "error",
            timeout: 3000,
          })
        );
        rejectWithValue(err);
      });
  }
);

export const updateCollectionDetailsById = createAsyncThunk(
  apiConstants.UPDATE_COLLECTION_DETALS_BYID,
  async (data, { dispatch, rejectWithValue }) => {
    return commonService
      .withToken(apiConstants.UPDATE_COLLECTION_DETALS_BYID, data)
      .then((response) => {
        return response.data;
      })
      .catch(async (err) => {
        let result = await errorHandler(err.response);
        dispatch(
          setAlert({
            msg: JSON.stringify(result),
            alertType: "error",
            timeout: 3000,
          })
        );
        rejectWithValue(err);
      });
  }
);

const errorHandler = async (response) => {
  try {
    if (response) {
      let arr = response.data.errors.map((x, index) => {
        if (index !== response.data.errors.length) {
          return x.msg + ",";
        } else {
          return x.msg;
        }
      });
      return arr;
    }
  } catch (err) {
    console.log("======== Error in ErrorHandler user slice ========", err);
  }
};

const initialState = {
  value: "",
  status: "",
};

export const collectionSlice = createSlice({
  name: "collection",
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [getAllCollections.fulfilled]: (state, action) => {
      state.value = action.payload;
      state.status = "fetched";
    },
    [getAllCollectionsByCreator.fulfilled]: (state, action) => {
      state.value = action.payload;
      state.status = "fetched";
    },
    [getAllCollectionsByName.fulfilled]: (state, action) => {
      state.value = action.payload;
      state.status = "fetched";
    },
    [getCollectionById.fulfilled]: (state, action) => {
      state.value = action.payload;
      state.status = "fetched";
    },
    [createCollection.fulfilled]: (state, action) => {
      state.value = action.payload;
      state.status = "created";
    },
    [updateCollectionDetailsById.fulfilled]: (state, action) => {
      state.value = action.payload;
      state.status = "created";
    },
  },
});

export default collectionSlice.reducer;
